import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@ribera-web/app-token';
import { Observable } from 'rxjs';
import { IUserDataResponse } from '../models/auth.models';
import {
  IChangePasswordRequestDto,
  IChangePasswordResponse,
  IForgetPasswordRequestDto,
  IForgetPasswordResponse,
  ISendOtpApiRequestDto,
  ISendOtpResponse,
  IValidateOtpApiRequestDto,
  IValidateOtpApiResponseDto,
} from '../models/account.model';

@Injectable({
  providedIn: 'root',
})
export class AccountApiService {
  private http = inject(HttpClient);
  private config = inject(APP_CONFIG);
  private apiUrl = this.config.ACCOUNT_MICROSERVICE_API + '/api/v2';
  //private apiUrl = 'http://localhost:8083/api/v2';
  private defaultToken =
    'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';

  private getAuthOptions(): { headers: HttpHeaders } {
    const sessionToken = localStorage.getItem('accessToken');
    const tokenToUse = sessionToken ? sessionToken : this.defaultToken;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${tokenToUse}`,
    });
    return { headers: headers };
  }

  getUserById(id: number): Observable<IUserDataResponse> {
    const options = this.getAuthOptions();
    return this.http.get<IUserDataResponse>(
      `${this.apiUrl}/user-clients/${id}`,
      options
    );
  }

  sendOtp(request: ISendOtpApiRequestDto): Observable<ISendOtpResponse> {
    const options = this.getAuthOptions();
    return this.http.post<ISendOtpResponse>(
      `${this.apiUrl}/verify-account/send-otp`,
      request,
      options
    );
  }

  validateOtp(
    request: IValidateOtpApiRequestDto
  ): Observable<IValidateOtpApiResponseDto> {
    const options = this.getAuthOptions();
    return this.http.post<IValidateOtpApiResponseDto>(
      `${this.apiUrl}/verify-account/validate-account`,
      request,
      options
    );
  }

  forgetPassword(
    request: IForgetPasswordRequestDto
  ): Observable<IForgetPasswordResponse> {
    const options = this.getAuthOptions();
    return this.http.post<IForgetPasswordResponse>(
      `${this.apiUrl}/user-clients/request-password-reset`,
      request,
      options
    );
  }

  resetPassword(
    userClientId: number,
    request: IChangePasswordRequestDto
  ): Observable<IChangePasswordResponse> {
    const options = this.getAuthOptions();
    return this.http.patch<IChangePasswordResponse>(
      `${this.apiUrl}/user-clients/change-password/${userClientId}`,
      request,
      options
    );
  }
}
